// Header.jsx:
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom'; // Import useNavigate
import logo from '../assets/ever.png';
import i18n from '../i18n';
import './Header.css';

function Header({ scrollToDownload }) {
    const { t } = useTranslation();
    const navigate = useNavigate(); // React Router navigation
    const [menuOpen, setMenuOpen] = useState(false);
    const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);
    const languageButtonRefDesktop = useRef(null);
    const languageButtonRefMobile = useRef(null);
    const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });

    // Close the language dropdown whenever the hamburger menu is toggled
    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
        setLanguageDropdownOpen(false); // <-- This line closes the language dropdown
    };

    const toggleLanguageDropdown = (isMobile = false) => {
        if (languageDropdownOpen) {
            setLanguageDropdownOpen(false);
            return;
        }
        let rect;
        if (isMobile && languageButtonRefMobile.current) {
            rect = languageButtonRefMobile.current.getBoundingClientRect();
        } else if (!isMobile && languageButtonRefDesktop.current) {
            rect = languageButtonRefDesktop.current.getBoundingClientRect();
        }
        if (rect) {
            setDropdownPosition({
                top: rect.bottom + window.scrollY + 5,
                left: rect.left + window.scrollX,
            });
        }
        setLanguageDropdownOpen(true);
    };

    const handleLanguageSelection = (languageCode) => {
        i18n.changeLanguage(languageCode)
            .then(() => {
                localStorage.setItem('language', languageCode);
                setLanguageDropdownOpen(false);
                setMenuOpen(false);
            })
            .catch((error) => console.error('Error changing language:', error));
    };

    const handleNavigation = (page) => {
        if (page === 'home') {
            navigate('/'); // Navigate to home screen
        } else if (page === 'contact') {
            navigate('/Contact'); // Navigate to TermsPrivacy.jsx when Contact is clicked
        } else if (page === 'investors') {
            navigate('/Investors'); // Navigate to Investors.jsx
        } else if (page === 'get_app' && scrollToDownload) {
            scrollToDownload(); // Scroll to download section
        }
        setMenuOpen(false);
        setLanguageDropdownOpen(false);
    };

    return (
        <>
            <header className="header">
                <div className="header-content">
                    <img src={logo} alt="Ever Logo" className="logo" />
                    <div className="nav-buttons">
                        <button className="nav-btn desktop-only" onClick={() => handleNavigation('home')}>
                            {t('home')}
                        </button>
                        {/*
                        <button className="nav-btn desktop-only" onClick={() => handleNavigation('about')}>
                            {t('about')}
                        </button>
                        */}
                        <button className="nav-btn desktop-only" onClick={() => handleNavigation('investors')}>
                            {t('investors')}
                        </button>
                        <button className="nav-btn desktop-only" onClick={() => handleNavigation('contact')}>
                            {t('contact')}
                        </button>

                        <button
                            ref={languageButtonRefDesktop}
                            className="nav-btn desktop-only"
                            onClick={() => toggleLanguageDropdown(false)}
                        >
                            {t('language')}
                        </button>

                        <button className="nav-btn1" onClick={() => handleNavigation('get_app')}>
                            {t('get_app')}
                        </button>

                        <button className="hamburger-btn" onClick={toggleMenu}>
                            &#9776;
                        </button>
                    </div>
                </div>

                <div className={`mobile-menu ${menuOpen ? 'show' : ''}`}>
                    <button className="nav-btn" onClick={() => handleNavigation('home')}>
                        {t('home')}
                    </button>
                    {/*
                    <button className="nav-btn" onClick={() => handleNavigation('about')}>
                        {t('about')}
                    </button>
                    */}
                    <button className="nav-btn" onClick={() => handleNavigation('investors')}>
                        {t('investors')}
                    </button>
                    <button className="nav-btn" onClick={() => handleNavigation('contact')}>
                        {t('contact')}
                    </button>

                    <button
                        ref={languageButtonRefMobile}
                        className="nav-btn"
                        onClick={() => toggleLanguageDropdown(true)}
                    >
                        {t('language')}
                    </button>
                </div>
            </header>

            {languageDropdownOpen && (
                <div
                    className="language-dropdown"
                    style={{ top: dropdownPosition.top, left: dropdownPosition.left }}
                >
                    <button onClick={() => handleLanguageSelection('en')}>English</button>
                    <button onClick={() => handleLanguageSelection('es')}>Español</button>
                    <button onClick={() => handleLanguageSelection('pt')}>Português</button>
                    <button onClick={() => handleLanguageSelection('it')}>Italiano</button>
                    <button onClick={() => handleLanguageSelection('al')}>Shqip</button>
                    <button onClick={() => handleLanguageSelection('de')}>Deutsch</button>
                    <button onClick={() => handleLanguageSelection('fr')}>Français</button>
                    <button onClick={() => handleLanguageSelection('gr')}>Ελληνικά</button>
                    <button onClick={() => handleLanguageSelection('ma')}>Arabic</button>
                    <button onClick={() => handleLanguageSelection('pl')}>Polski</button>
                    <button onClick={() => handleLanguageSelection('ro')}>Română</button>
                </div>
            )}
        </>
    );
}

export default Header;
